var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',{attrs:{"size":_vm.size},on:{"click":_vm.handleViewAuditDetail}},[_vm._v("审核详情")])
}
var staticRenderFns = []

export { render, staticRenderFns }